/* eslint-disable import/no-anonymous-default-export */
import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import MainLayout from "../common/components/MainLayout";
import UsuariosContext from "../common/contexts/UsuariosContext";
import Encabezado from "./components/Encabezado";
import TablaResumen from "./components/TablaResumen";

const StyledWelcome = styled.div`
  margin-bottom: 2rem;
  font-size: 1.5rem;
  font-weight: 600;
  border-bottom: 1px solid;
  padding-bottom: 0.75rem;
  color: #757575;
`;

export default () => {
  const usuariosContext = useContext(UsuariosContext);
  const navigate = useNavigate();


  useEffect(() => {
    if (usuariosContext.user?.rol.nombre === "Juzgado" || usuariosContext.user?.rol.nombre === "Cobranzas" ) {
      navigate("/juzgado-consulta");
    }
  }, []);

  const tienePermisosEspeciales = () => {
    const nombresPermitidos: string[] = JSON.parse(process.env.REACT_APP_NOMBRES_PERMITIDOS_ESTADISTICA ?? "[]");
    const nombreCompleto = `${usuariosContext.user?.nombre}${usuariosContext.user?.apellido}`
      .replace(/\s+/g, "")
      .toUpperCase();
    console.log(nombreCompleto)
    console.log(process.env.REACT_APP_NOMBRES_PERMITIDOS_ESTADISTICA)
    return nombresPermitidos.includes(nombreCompleto);
  };

  return (
    <MainLayout maxContentWidth={90}>
      <StyledWelcome>
        Bienvenido {usuariosContext.user?.nombre}{" "}
        {usuariosContext.user?.apellido}
      </StyledWelcome>
      {tienePermisosEspeciales() && (
    <>
      <Encabezado />
      <TablaResumen />
    </>
  )}
    </MainLayout>
  );
};
